import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import StripeButton from '../../components/atoms/StripeButton';
import BackButton from '../../components/atoms/BackButton';
import { isAuthenticated } from '../../auth/Auth';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  pageTitileDiv: {
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  mainPaper: {
    position: 'relative',
    margin: 20
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  boldText: {
    fontWeight: 'bold',
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  boldRed: {
    fontWeight: 'bold',
    color: '#ff0000'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    account: state.accounts.account,
    name: state.loginInfo.name
  })),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
    }
  })
);

const Main = enhance(
  ({
    classes,
    account,
    name,
    openDrawer,
    updateOpenDrawer,
    handleRedirect
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;
    const stripeAccountDone =
      account &&
      account.accountStatus &&
      account.accountStatus.stripeAccount === true;
    const backAction = () => handleRedirect('/release_step');
    const disableRegisStripe = account && account.paymentGroupId;
    console.log('disableRegisStripe', disableRegisStripe);
    return (
      <div className={classes.root}>
        <Header
          name={name}
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            Stripe紐付け
          </Typography>
          <Typography color="textSecondary">
            Stripe紐付けを行うことで、振込サイクルの変更や入金日のご確認ができるようになります
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            {!stripeAccountDone ? (
              <React.Fragment>
                <TableRow>
                  <TableCell className={classes.tableCellData}>
                    <div className={classes.boldText}>{account.email}</div>
                    <div className={classes.boldRed}>
                      下記、Stripeで登録するメールアドレスは、こちらに表示されているごちめし登録のメールアドレスと同一のメールアドレスで、登録してください。
                      <br />
                      {`（ `}
                      ごちめしとStripeを紐付けるには2つのメールアドレスが一致している必要があります。
                      {` ）`}
                    </div>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell className={classes.tableCellData}>
                    <StripeButton disabled={disableRegisStripe} />
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ) : (
              <TableRow>
                <TableCell className={classes.tableCellData}>
                  <div className={classes.boldText}>
                    既にStripeに紐づけています。
                  </div>
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell className={classes.tableCellData}>
                <div>
                  <Link
                    href="https://drive.google.com/file/d/1BKfAXptdSVANRoX9DGO-IDu3vDi49CaL/view"
                    target="_blank"
                    className={classes.link}
                  >
                    Stripeに関するよくある質問はこちら
                  </Link>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.tableCellData}>
                <div>
                  <Link
                    href={`${process.env.PUBLIC_URL}/others/stripe_regist.pdf`}
                    target="_blank"
                    className={classes.link}
                  >
                    登録手順はこちら
                  </Link>
                </div>
              </TableCell>
            </TableRow>
            {/* <TableRow>
              <TableCell className={classes.tableCellData}>
                <div>
                  <Link
                    href="https://dashboard.stripe.com/login"
                    target="_blank"
                    className={classes.link}
                  >
                    Stripeログイン画面はこちら
                  </Link>
                </div>
              </TableCell>
            </TableRow> */}
          </Table>
          {isShop && !isReleased && (
            <div>
              <BackButton onClickAction={backAction} />
            </div>
          )}
        </Paper>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
